<template>
  <div class="dash-body">
    <div class="dash-empty">
      <div class="alert" v-if="showPlanSuggestion">
        <p>
          {{ $t('INTRO_START_CURRENTLY_PLAN') }}
          <a href="plans">{{ $t('INTRO_START_PRICING') }}</a>
        </p>
        <span class="close" @click="showPlanSuggestion = false"><i class="bi bi-x-lg"></i></span>
      </div>
      <img src="@/assets/images/image 61.svg" alt />
      <div class="welcome">
        <div class="b40">{{ $t('INTRO_START_EMPTY_LIST') }}</div>
        <div class="r16" v-if="hasActivePlan">{{ $t('INTRO_START_START_JOURNEY') }}</div>
        <div class="r16" v-if="neverHadPlan">{{ $t('INTRO_START_NO_PLAN') }}</div>
        <div class="r16" v-if="planExpired">{{ $t('INTRO_START_PLAN_EXPIRED') }}</div>
        <button 
          class="btn-st-red" 
          v-if="hasActivePlan"
          @click="INTRO_SET_ADD_PAGE_VISIBLE(true)"
        >
          {{ $t('INTRO_START_ADD_PAGE') }}
        </button>
        <div class="buttons-trial" v-if="!hasActivePlan">
          <button class="btn-st-red" @click="goToPlans">
            {{ $t('PRICING_TITLE') }}
          </button>
          <button class="btn-st-tr" v-if="canStartTrial" @click="startTrial">
            {{ $t('TRIAL_ACTIVATE') }}
          </button>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { INTRO_SET_ADD_PAGE_VISIBLE } from "../../../store/actions/intro";

export default {
  name: "Intro-start",
  computed: {
    ...mapGetters(['getProfile']),
    hasActivePlan() {
      return this.getProfile && 
             (this.getProfile.plan || this.getProfile.planId) && 
             (this.getProfile.daysLeft === undefined || this.getProfile.daysLeft > 0);
    },
    planExpired() {
      return this.getProfile &&
             (this.getProfile.plan || this.getProfile.planId) &&
             this.getProfile.daysLeft !== undefined &&
             this.getProfile.daysLeft <= 0;
    },
    neverHadPlan() {
      return this.getProfile && 
             !this.hasActivePlan && 
             !this.planExpired;
    },
    canStartTrial() {
      // Триал даём новому пользователю и тому, чей триал истёк, — но только если он
      // ни разу не платил: то же правило на сервере (routes/safed/create-test-plan.js).
      if (this.hasActivePlan) return false;
      if (this.neverHadPlan) return true;
      return String((this.getProfile && this.getProfile.payment_system) || "").toLowerCase() === "trial";
    },
    showPlanSuggestion() {
      // Only show alert if user had a plan before but it's not active now
      return !this.hasActivePlan && !this.neverHadPlan;
    }
  },
  methods: {
    ...mapMutations([INTRO_SET_ADD_PAGE_VISIBLE]),
    ...mapActions({
      activateTrial: 'AUTH_ACTIVATE_TRIAL',
      loadCategories: 'CATEGORIES_SET_LIST'
    }),
    goToPlans() {
      this.$router.push('/plans');
    },
    async startTrial() {
      try {
        const result = await this.activateTrial();
        
        if (result && result.success === true) {
          // The action handles the redirect and alert
        } else {
          throw new Error('Trial activation failed');
        }
      } catch (error) {
        
        // Show error message
        this.$store.dispatch('alerts/addAlert', {
          message: error.error || this.$t('UNKNOWN_ERROR_OCCURRED'),
          color: 'danger',
          duration: 5000
        }, { root: true });
      }
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    // Load categories even when user has no pages
    this.loadCategories();
  },
};
</script>

<style>
</style>